import { resi18nutil } from 'language/resi18nutil';

const resi18n_common = {
  I18N_COMMON_TIT_MAIN: ['솔루션스퀘어', 'Solution Square', undefined],
  I18N_COMMON_TIT_QNA: ['Q&A - 솔루션스퀘어', 'Q&A - Solution Square', undefined],
  I18N_COMMON_TIT_TECHLOG: ['Knowledge Base - 솔루션스퀘어', 'Knowledge Base - Solution Square', undefined],
  I18N_COMMON_TIT_BOARD: ['게시판 - 솔루션스퀘어', 'Board - Solution Square', undefined],
  I18N_COMMON_TIT_SAMPLE: ['샘플라이브러리 - 솔루션스퀘어', 'sample - Solution Square', undefined],
  I18N_COMMON_TIT_PROD: ['제품 - 솔루션스퀘어', 'product - Solution Square', undefined],
  I18N_COMMON_TIT_INDUST: ['산업 - 솔루션스퀘어', 'industry - Solution Square', undefined],
  I18N_COMMON_TIT_ONLINE_TRAINING: ['실시간 강의실 - 솔루션스퀘어', 'online training - Solution Square', undefined],
  I18N_COMMON_TIT_REMOTE_SUPPORT: ['원격지원 - 솔루션스퀘어', 'remote support - Solution Square', undefined],
  I18N_COMMON_TIT_SEARCH: ['검색 - 솔루션스퀘어', 'search - Solution Square', undefined],
  I18N_COMMON_TIT_PROFILE: ['프로필 - 솔루션스퀘어', 'profile - Solution Square', undefined],
  I18N_COMMON_TIT_PRODUCT_SELECTOR: [
    'Product Selector - 서비스 - 솔루션스퀘어',
    'Product Selector - Service - Solution Square',
    undefined,
  ],
  I18N_COMMON_TIT_ENERGY_SAVE: [
    '에너지 절감 시뮬레이터 - 서비스 - 솔루션스퀘어',
    'Energy Saving Simulator - Service - Solution Square',
    undefined,
  ],
  I18N_COMMON_TIT_ASSET: [
    'Asset Insight - 서비스 - 솔루션스퀘어',
    'Asset Insight - Service - Solution Square',
    undefined,
  ],
  I18N_COMMON_ADMIN_SETTING: ['관리자 설정 - 솔루션 스퀘어', 'Admin settings -Solution Square', undefined],
  I18N_COMMON_TIT_SW_SERVICE: ['SW 서비스 - 솔루션스퀘어', 'SW Service - Solution Square', undefined],
  I18N_COMMON_TIT_RND: ['RnD - 커뮤니티 - 솔루션스퀘어', 'RnD - Community - Solution Square', undefined],
  I18N_COMMON_TIT_PARTNER: ['Partner - 커뮤니티 - 솔루션스퀘어', 'Partner - Community - Solution Square', undefined],

  // Product Selector.
  I18N_PRODSEL_SAVE: ['저장하기', 'Save', undefined],
  I18N_PRODSEL_SAVE_DESC: [
    '새로 만들거나, 덮어 쓸 파일을 선택하세요.',
    'Add a new list, or select a list to overwrite.',
    undefined,
  ],
  I18N_PRODSEL_MSG_SELECT_OVERWRITE: ['덮어 쓸 목록을 선택주세요.', 'Please select a list to overwrite.', undefined],
  I18N_PRODSEL_OPEN_DESC: ['불러올 프로젝트를 선택하세요.', 'Select a project to open', undefined],
  I18N_PRODSEL_SAVE_DONE: ['목록이 저장되었습니다', 'The list has been saved.', undefined],
  I18N_PRODSEL_SELECT_OVERWRITE_ITEM: ['덮어 쓸 목록을 선택주세요', 'Please select a list to overwrite', undefined],
  I18N_PRODSEL_TITLE: ['제목', 'Title', undefined],
  I18N_PRODSEL_DESC: ['설명', 'Description', undefined],
  I18N_PRODSEL_PLACEHOLDER: ['20자 이내 텍스트', 'Max. 20 characters', undefined],
  I18N_PRODSEL_PLACEHOLDER2: ['100자 이내 텍스트', 'Max. 100 characters', undefined],
  I18N_PRODSEL_INPUT_ERR_MSG: ['20자 이내 텍스트를 입력해 주세요.', 'Enter max. 20 characters.', undefined],
  I18N_PRODSEL_BTN_NEW: ['새로 만들기', 'New', undefined],
  I18N_PRODSEL_BTN_OVERWRITE: ['덮어 쓰기', 'Overwrite', undefined],
  I18N_PRODSEL_BTN_CANCEL: ['취소', 'Cancel', undefined],
  I18N_PRODSEL_BTN_SAVE: ['저장하기', 'Save', undefined],
  I18N_PRODSEL_OPEN: ['프로젝트 열기', 'Open Project', undefined],
  I18N_PRODSEL_BTN_OPEN: ['열기', 'Open', undefined],
  I18N_PRODSEL_NO_LIST: ['저장된 리스트가 없습니다.', 'There is no list.', undefined],
  I18N_PRODSEL_SAVE_ALERT: [
    '프로젝트를 열기 시 저장되지 않은 목록은 사라집니다.',
    'Unsaved lists will disappear when you open the project.',
    undefined,
  ],
  I18N_PRODSEL_RESET_CONFIRM: [
    '선택한 정보를 초기화 하시겠습니까?',
    'Do you want to reset the selected information?',
    undefined,
  ],
  I18N_PRODSEL_SERVO_COPY_CONFIRM: [
    '선택된 데이터가 있습니다. 카피하시겠습니까?',
    'There is already a selection. Do you want to copy?',
    undefined,
  ],
  I18N_PRODSEL_LIST_SAVE: ['목록에 담기', 'Add item', undefined],
  I18N_PRODSEL_LIST_SAVE_DESC: [
    '기존 목록에 담거나, 새 목록에 담으세요.',
    'Update existing project or Create a new project.',
    undefined,
  ],
  I18N_PRODSEL_MY_LIST: ['내 목록', 'My Projects', undefined],
  I18N_PRODSEL_NOT_EXIST_MY_LIST: ['내 목록이 없습니다.', 'There is no project on the list yet.', undefined],
  I18N_PRODSEL_MADE_MY_LIST: [
    '새로 만들기를 선택하여 목록을 만드세요.',
    'Click new to create your own project.',
    undefined,
  ],
  I18N_PRODSEL_ADD: ['담기', 'Add', undefined],
  I18N_PRODSEL_MODIFY_TITLE_DESC: ['수정되었습니다.', 'The change has been completed.', undefined],
  I18N_PRODSEL_MODIFY: ['수정하기', 'Modify', undefined],
  I18N_PRODSEL_NEW_LIST: ['새 프로젝트', 'New Project', undefined],
  I18N_PRODSEL_NEW_LIST_DESC: ['담은 목록을 새 프로젝트로 저장합니다.', 'Create a New Project', undefined],
  I18N_PRODSEL_MAX_TEN: ['Max 10개. 오래된 순으로 삭제', 'Max. 10 (Delete by oldest)', undefined],
  I18N_PRODSEL_MODIFY_DESC: ['프로젝트 정보를 수정하세요.', 'Modify the Project.', undefined],
  I18N_PRODSEL_SAVE_ONE: ['저장할 제품이 없습니다.', 'There are no products to save.', undefined],
  I18N_COMMON_PARTNER: ['파트너', 'Partner', undefined],
  I18N_COMMON_PARTNER_ONLY: ['파트너 전용', 'Partner Only', undefined],
  I18N_COMMON_LOGIN_ONLY: ['회원 전용', 'Member Only', undefined],

  // main2.
  i18n_srch_dd_all: ['전체', 'ALL', undefined],
  i18n_srch_dd_dlcenter: ['다운로드 센터', 'Download Center', undefined],
  i18n_srch_dd_knowledge: ['Knowledge Base', 'Knowledge Base', undefined],
  i18n_srch_dd_sample: ['샘플 라이브러리', 'Sample', undefined],
  i18n_srch_dd_qna: ['Q&A', 'Q&A', undefined],
  i18n_srch_dd_news_evnet: ['뉴스/이벤트', 'News/Event', undefined],

  i18n_srch_input_placeholder: ['검색어를 입력하세요.', 'Enter the search keyword.', undefined],
  i18n_srch_input_ai_mode: ['AI 모드', 'AI Mode', undefined],

  i18n_srch_hiro_text: [
    '안녕하세요? 저는 AI 상담사 히로입니다.',
    'Hello! Welcome to Solution Square. How can I help you today?',
    undefined,
  ],

  i18n_srch_hurt_hero_msg: [
    '제 생각을 읽으려고 하시는 건가요? 10번 클릭으로는 어림없습니다! ❤️',
    'Are you trying to read my mind? Ten clicks won’t even come close! ❤️',
    undefined,
  ],

  i18n_srch_hurt_2_hero_msg: ['그만 누르세요...크아아앙!🔥', '20 Clicks seriously? GRRR  🔥 ', undefined],

  i18n_doc_new: ['신규', 'New Document', undefined],
  i18n_doc_copy: ['복제', 'Duplicate', undefined],
  i18n_doc_delete: ['삭제', 'Delete', undefined],
  i18n_doc_new_desc: [
    '새로운 문서가 생성됩니다. 신규 생성할 항목을 선택해 주세요.',
    'A new document will be created. Please select a region to create it.',
    undefined,
  ],
  i18n_doc_copy_desc: [
    '현재 문서가 복제됩니다. 생성할 항목을 선택해 주세요.',
    'The document will be duplicated. Please select a region to duplicate it to.',
    undefined,
  ],
  i18n_doc_region: ['생성 항목', 'Region', undefined],

  i18n_dd_doc_new: ['신규', 'New', undefined],
  i18n_dd_doc_copy: ['복제', 'Duplicate', undefined],
  i18n_dd_doc_delete: ['삭제', 'Delete', undefined],
  i18n_dd_tag: ['태그', 'Tags', undefined],
  i18n_dd_auth: ['권한', 'Auth', undefined],

  i18n_tag_search_placeholder: ['태그 검색', 'Search tags', undefined],

  i18n_confirm: ['확인', 'Confirm', undefined],
  i18n_save: ['저장', 'Save', undefined],
  i18n_cancel: ['취소', 'Cancel', undefined],
  i18n_type: ['유형', 'Type', undefined],
  i18n_prod_category: ['제품 카테고리', 'Product Category', undefined],
  i18n_file_lang: ['파일 언어', 'File Language', undefined],
  i18n_category_placeholder: ['제품 카테고리를 검색해보세요.', 'Enter the product category.', undefined],
  i18n_all: ['전체', 'All', undefined],
  i18n_site_lang: ['지역', 'Region', undefined],
  i18n_tag: ['태그', 'Tags', undefined],
  i18n_tag_search_placeholder2: ['태그를 검색해보세요.', 'Enter the tag.', undefined],
  i18n_filter: ['필터', 'Filter', undefined],
  i18n_menu: ['메뉴', 'Menu', undefined],

  i18n_recent_tags: ['최근 태그', 'Recent Tags', undefined],

  i18n_sample_library: ['샘플 라이브러리', 'Sample Library', undefined],
  i18n_knowledge_leader: ['지식 공유자', 'Top Knowledge Leaders', undefined],
  i18n_knowledge_msg1: ['SSQ 지식 여정을 함께하는 영웅들', 'Top Users', undefined],
  i18n_knowledge_msg2: ['연결된 지식, 확장된 가능성', 'Best Members', undefined],
  i18n_knowledge_msg3: ['모두의 지혜가 모이는 곳', 'Knowledge Innovators', undefined],
  i18n_qna_desc: ['전문가들과 함께 문제를 해결해 보세요.', 'Consult with our experts for solutions.', undefined],
  i18n_qna_recent: ['최근 많이 본 질문', 'Top Viewed Questions', undefined],
  i18n_qna_wait: ['답변을 기다리는 질문', 'Questions Awaiting Answers', undefined],

  i18n_hiro_text_title: ['Hiro 문구 설정', 'Hiro Text Setting', undefined],
  i18n_hiro_text_guide: [
    'Hiro 문구 설정을 해 주세요. $User 는 로그인시 표시될 이름입니다.',
    'Please set the Hiro Text. $User is the name to be displayed when logged in.',
    undefined,
  ],
  i18n_hiro_text_guide1: [
    '로그인 전 표시될 문구를 입력해 주세요.',
    'Enter the text to be displayed before login.',
    undefined,
  ],
  i18n_hiro_text_guide2: [
    '로그인 후 표시될 문구를 입력해 주세요.',
    'Enter the text to be displayed after login.',
    undefined,
  ],

  i18n_goto_tech_square: ['테크스퀘어 바로가기', 'Go to Tech Square', undefined],

  i18n_no_doc_title: ['조회된 문서가 없습니다.', 'No results found.', undefined],
  i18n_no_doc_desc: ['필터를 설정해 주세요', 'Please refine your search using the search filters.', undefined],
  i18n_no_doc_btn: ['검색 옵션 초기화', 'Reset all search filters.', undefined],

  i18n_tech_square_title: [
    'Tech Square는 다양한 업종의 스마트 제조 솔루션을 필요로 하는 수요기업과 구축에 최적화된 공급기업을 매칭해주는 서비스입니다. 스마트 안전, 제조를 위한 혁신 솔루션을 지금 바로 경험해 보세요.',
    'Thinking about Smart Manufacturing?',
    undefined,
  ],
  i18n_tech_square_desc: [
    '',
    'Out experts at &nbsp; <img src="{{img_tech_square}}" /> &nbsp; guide you from start to finish.',
    undefined,
  ],

  i18n_lselectric_homepage_title: [
    'LS ELECTRIC의 혁신적인 솔루션을 모두 만나보세요.',
    "Discover LS ELECTRIC's full range of innovative solutions.",
    undefined,
  ],
  i18n_lselectric_homepage_desc: [
    '기술에 대한 깊이 있는 정보를 원하신다면 공식 웹사이트를 방문해 주세요.',
    'Visit the official website for in-depth technology insights',
    undefined,
  ],
  i18n_goto_lselectric_homepage: ['공식 웹사이트 바로가기', 'Go to LS ELECTRIC website', undefined],

  i18n_quick_link_add: ['퀵링크 추가', 'Add Quick Link', undefined],
  i18n_quick_link_title: ['퀵 링크 설정', 'Quick Links Setting', undefined],
  i18n_quick_link_guide: [
    '자주 활용하시는 메뉴를 퀵 링크로 등록하십시오. <br /> 최대 8개까지 등록 가능합니다.',
    'Set your frequently used menus as Quick Links. <br />You can add up to 8',
    undefined,
  ],

  i18n_head_menu_mypage: ['마이 페이지', 'My Page', undefined],
  i18n_head_menu_account_settings: ['프로필 관리', 'Account Setting', undefined],
  i18n_head_menu_admin_settings: ['관리자 설정', 'Admin Setting', undefined],

  i18n_home: ['메인', 'Main', undefined],
  i18n_title: ['제목', 'Title', undefined],
  i18n_download: ['다운로드', 'Download', undefined],
  i18n_bookmark: ['북마크', 'Bookmark', undefined],
  i18n_copy_link: ['공유', 'Copy Link', undefined],
  i18n_delete: ['삭제', 'Delete', undefined],
  i18n_more: ['더보기', 'More', undefined],
  i18n_reset: ['초기화', 'Reset', undefined],
  i18n_cnt: ['개', 'items', undefined],

  i18n_same: ['일치', 'Same', undefined],
  i18n_different: ['불일치', 'Different', undefined],
  i18n_undefined: ['미설정', 'Undefined', undefined],
  i18n_compare: ['비교', 'Compare', undefined],

  i18n_quick_link_max: ['최대 8개까지 설정할 수 있습니다.', 'You can set up to 8', undefined],

  i18n_page_title_dlcenter: ['다운로드 센터', 'Download Center', undefined],

  i18n_match_all: ['모두 일치(AND)', 'Match All(AND)', undefined],
  i18n_match_any: ['선택 일치(OR)', 'Match Any(OR)', undefined],
  i18n_mobile_ai_mode_use: ['AI 검색 사용', 'Use AI Search', undefined],
  i18n_main_notice_link_text: ['바로 가기', 'View Details', undefined],
  i18n_main_notice_notice: ['공지사항', 'Notice', undefined],
  i18n_main_notice_event: ['이벤트', 'Event', undefined],
  i18n_model_nm: ['모델', 'Model', undefined],
  i18n_select_all: ['전체 선택', 'Select all', undefined],

  i18n_dlcenter_classic_view: ['클래식뷰', 'Classic View', undefined],

  i18n_fb_doc_req_update_title: ['문서 수정 요청', 'Document Update Request', undefined],
  i18n_fb_title_view_detail: ['상세 보기', 'View Detail', undefined],
  i18n_add_attach_file: ['첨부파일 추가', 'Add Attach File', undefined],

  i18n_fb_stat_reg: ['접수', 'Registration', undefined],
  i18n_fb_stat_asgn: ['배정', 'Assignment', undefined],
  i18n_fb_stat_rej: ['반려', 'Rejection', undefined],
  i18n_fb_stat_done: ['완료', 'Completion', undefined],
  i18n_fb_stat_delay: ['지연', 'Delay', undefined],
  i18n_fb_stat_result: ['조회결과', 'Search Result', undefined],

  i18n_fb_pop_follower: ['담당자', 'Follower', undefined],
  i18n_fb_pop_completion_request_date: ['완료요청일', 'Completion Request Date', undefined],
  i18n_fb_pop_status: ['상태', 'Status', undefined],
  i18n_fb_pop_doc_type: ['문서 유형', 'Document Type', undefined],
  i18n_fb_pop_doc_title: ['문서명', 'Document Name', undefined],
  i18n_fb_pop_category: ['카테고리', 'Category', undefined],
  i18n_fb_pop_title_placeholder: [
    '제목 (한국어, 50자 이하 텍스트)',
    'Title (Korean, 50 characters or less)',
    undefined,
  ],
  i18n_fb_pop_doc_sel_title: ['피드백 문서 선택', 'Feedback Document Selection', undefined],

  i18n_fb_pop_title_chg_reason: ['수정 사유', 'Modification Reason', undefined],
  i18n_fb_pop_chg_reason_desc1: [
    '상태를 변경한 사유를 작성해 주세요.',
    'Enter the reason for changing the status.',
    undefined,
  ],
  i18n_fb_pop_chg_reason_desc2: [
    '미입력시 상태 변경 사항이 저장되지 않습니다.',
    'If not entered, the status change will not be saved.',
    undefined,
  ],
  i18n_fb_pop_chg_confirm_desc1: [
    '사유 미작성시 상태가 변경되지 않습니다.',
    'If the reason is not entered, the status will not be changed.',
    undefined,
  ],
  i18n_fb_pop_chg_confirm_desc2: [
    '사유를 작성을 그만두고 나가시겠습니까?',
    'Do you want to exit without entering the reason?',
    undefined,
  ],

  i18n_fb_pop_btn_goout: ['나가기', 'Go out', undefined],
  i18n_fb_pop_btn_continue: ['계속 작성', 'Continue', undefined],

  i18n_file_delete_failed: ['파일 삭제에 실패하였습니다.', 'File deletion failed.', undefined],

  i18n_doc_grp_sel_title: ['그룹 문서 선택', 'Group Document Selection', undefined],
  i18n_doc_grp_sel_desc: ['문서를 선택해 주세요.', 'Select a document.', undefined],
  i18n_select: ['선택', 'Select', undefined],
  i18n_doc_grp_sett_title: ['그룹 문서 설정', 'Group Document Setting', undefined],

  i18n_doc_copy_title: ['문서 복제', 'Document Copy', undefined],
  i18n_doc_copy_item_title_content: ['제목 및 본문', 'Title and Content', undefined],
  i18n_doc_copy_item_version_attach: ['최신버전 및 첨부파일', 'Latest Version and Attachments', undefined],
  i18n_category: ['카테고리', 'Category', undefined],
  i18n_thumnail_image: ['썸네일 이미지', 'Thumbnail Image', undefined],
  i18n_doc_grp_sett_item_select: ['비교항목 선택', 'Select Comparison Items', undefined],
  i18n_doc_grp_sett_desc: [
    '그룹 문서를 등록하고, 비교 항목을 선택해 주세요.',
    'Register a group document and select comparison items.',
    undefined,
  ],

  i18n_korea: ['대한민국', 'Korea', undefined],
  i18n_global: ['Global', 'Global', undefined],
  i18n_usa: ['USA', 'USA', undefined],
  i18n_division: ['구분', 'Division', undefined],
  i18n_doc_id: ['문서번호', 'Document ID', undefined],
  i18n_version: ['버전', 'Version', undefined],
  i18n_update: ['업데이트', 'Update', undefined],
  i18n_attachment: ['첨부파일', 'Attachment', undefined],
  i18n_expose_state: ['공개상태', 'Expose State', undefined],
  i18n_target: ['대상', 'Target', undefined],
  i18n_open: ['공개', 'Open', undefined],
  i18n_no_open: ['비공개', 'Closed', undefined],
  i18n_change_history: ['변경이력', 'Change History', undefined],
  i18n_reason: ['사유', 'Reason', undefined],

  i18n_fb_log_reg: [
    '{{userName}} 님이 피드백을 접수 하였습니다.',
    '{{userName}} registered a new feedback.',
    undefined,
  ],
  i18n_fb_log_doc_id2: [
    '문서번호가 {{fromDocId}} 에서 {{toDocId}} 로 변경되었습니다.',
    'Document number changed from {{fromDocId}} to {{toDocId}}.',
    undefined,
  ],
  i18n_fb_log_doc_id1: [
    '문서번호가 {{toDocId}} 로 변경되었습니다.',
    'Document number changed to {{toDocId}}.',
    undefined,
  ],
  i18n_fb_log_due_date: [
    '완료 예정일이 {{fromDueDate}} 에서 {{toDueDate}} 로 변경되었습니다.',
    'Due date changed from {{fromDueDate}} to {{toDueDate}}.',
    undefined,
  ],
  i18n_fb_stat_changed: [
    '{{fromStat}} 에서 {{toStat}} (으)로 상태가 변경되었습니다.',
    'Status changed from {{fromStat}} to {{toStat}}.',
    undefined,
  ],
  i18n_fb_follower_id_changed: [
    '담당자가 {{fromFollowerId}} 에서 {{toFollowerId}} (으)로 변경되었습니다.',
    'Follower changed from {{fromFollowerId}} to {{toFollowerId}}.',
    undefined,
  ],
  i18n_fb_usertbl_doc_type: ['문서유형', 'Document Type', undefined],
  i18n_fb_usertbl_follower: ['담당자', 'Follower', undefined],
  i18n_fb_reg_stat_cannot_change_follower: [
    '접수 상태에서는 담당자를 변경할 수 없습니다.',
    'You cannot change the follower in the registration status.',
    undefined,
  ],
  i18n_fb_pop_title_required: ['제목을 입력해 주세요.', 'Please enter the title.', undefined],
  i18n_fb_pop_desc_required: ['본문을 입력해 주세요.', 'Please enter the description.', undefined],
  i18n_fb_pop_no_change: ['변경사항이 없습니다.', 'No changes have been made.', undefined],
  i18n_fb_pop_doc_id_required: ['수정할 문서를 선택해 주세요.', 'Please select a document to update.', undefined],
  i18n_fb_pop_feedback_registered: ['피드백이 등록되었습니다.', 'Feedback registered.', undefined],

  i18n_failed_to_save: ['저장에 실패하였습니다.', 'Failed to save.', undefined],
  i18n_save_done: ['저장되었습니다.', 'Saved.', undefined],
  i18n_input_required_fields: ['필수 항목을 입력해 주세요.', 'Please enter the required fields.', undefined],
  i18n_write_a_comment: ['댓글을 입력해 주세요.', 'Write a comment...', undefined],
  i18n_please_enter_a_comment: ['댓글을 입력해 주세요.', 'Please enter a comment.', undefined],
  i18n_employee: ['임직원', 'Employee', undefined],

  i18n_svc_doc_log_reg: [
    '{{userName}} 님이 서비스 요청을 접수 하였습니다.',
    '{{userName}} registered a new service request.',
    undefined,
  ],
  i18n_svc_doc_log_status_change: [
    '{{userName}} 님이 상태를 {{toStat}} 으로 변경하였습니다.',
    '{{userName}} changed the status to {{toStat}}.',
    undefined,
  ],
  i18n_svc_doc_log_due_date_change: [
    '{{userName}} 님이 완료 예정일을 {{dueDate}} 로 변경하였습니다.',
    '{{userName}} changed the due date to {{dueDate}}.',
    undefined,
  ],
  i18n_svc_doc_log_update: [
    '{{userName}} 님이 정보를 업데이트 하였습니다.',
    '{{userName}} updated the information.',
    undefined,
  ],
  i18n_tech_doc_log_reg: [
    '{{userName}} 님이 기술지원 문의를 접수 하였습니다.',
    '{{userName}} registered a new technical support request.',
    undefined,
  ],
  i18n_tech_doc_log_status_change: [
    '{{userName}} 님이 상태를 {{toStat}} 으로 변경하였습니다.',
    '{{userName}} changed the status to {{toStat}}.',
    undefined,
  ],
  i18n_tech_doc_log_due_date_change: [
    '{{userName}} 님이 완료 예정일을 {{dueDate}} 로 변경하였습니다.',
    '{{userName}} changed the due date to {{dueDate}}.',
    undefined,
  ],
  i18n_tech_doc_log_update: [
    '{{userName}} 님이 정보를 업데이트 하였습니다.',
    '{{userName}} updated the information.',
    undefined,
  ],
  i18n_ptnr_admin_user_id_change_confirm: [
    '파트너 관리자 ID를 변경하시겠습니까?',
    'Do you want to change the partner admin user ID?',
    undefined,
  ],
  i18n_ptnr_select_spg: ['SPG를 선택해 주세요.', 'Please select an SPG.', undefined],
  i18n_ptnr_invalid_serial_no: ['시리얼 번호는 11자리여야 합니다.', 'The serial number must be 11 digits.', undefined],
  i18n_ptnr_select_partner: ['파트너', 'Partner', undefined],
  i18n_list: ['목록', 'List', undefined],
  // CTP 서보 구매 임시 화면(정식 구매 UI 전까지 orgCd/itemCode/quantity 직접 입력)
  I18N_CTP_PURCHASE_TITLE: ['서보 구매 요청 (임시)', 'Servo purchase request (temporary)', undefined],
  I18N_CTP_PURCHASE_ORG_CD: ['사업장 코드', 'Org code', undefined],
  I18N_CTP_PURCHASE_ITEM_CODE: ['품목 코드', 'Item code', undefined],
  I18N_CTP_PURCHASE_QUANTITY: ['수량', 'Quantity', undefined],
  I18N_CTP_PURCHASE_BUTTON: ['구매하기', 'Purchase', undefined],
  I18N_CTP_PURCHASE_SUBMITTING: ['요청 중...', 'Submitting...', undefined],
  I18N_CTP_PURCHASE_ERR_ITEM_REQUIRED: ['품목 코드를 입력해 주세요.', 'Please enter an item code.', undefined],
  I18N_CTP_PURCHASE_ERR_QUANTITY: [
    '수량은 1 이상 9999 이하의 정수여야 합니다.',
    'Quantity must be an integer from 1 to 9999.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_LOGIN: [
    '로그인이 필요합니다. 로그인 후 다시 시도해 주세요.',
    'Sign-in is required. Please sign in and try again.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_ITEM_NOT_FOUND: ['등록되지 않은 품목입니다: {{item}}', 'Item not found: {{item}}', undefined],
  I18N_CTP_PURCHASE_ERR_ITEM_NOT_ORDERABLE: [
    '현재 주문할 수 없는 품목입니다: {{item}}',
    'Item is not orderable right now: {{item}}',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_CONFLICT: [
    '이전 요청과 내용이 달라 새 요청 번호로 다시 시도해 주세요.',
    'The request changed. Please try again; a new request id will be used.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_INVALID: ['요청 내용이 올바르지 않습니다.', 'The request is invalid.', undefined],
  I18N_CTP_PURCHASE_ERR_NETWORK: [
    '서버와 통신하지 못했습니다. 같은 내용으로 다시 시도할 수 있습니다.',
    'Could not reach the server. You can retry with the same request.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_INVALID_RESPONSE: [
    '주문 요청 결과를 확인하지 못했습니다. 같은 내용으로 다시 시도해 주세요.',
    'Could not confirm the order request. Please retry with the same request.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_POPUP_BLOCKED: [
    '새 탭을 열 수 없습니다. 브라우저의 팝업 차단을 해제한 뒤 다시 시도해 주세요.',
    'Could not open a new tab. Please allow pop-ups for this site and try again.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_TAB_CLOSED: [
    '주문 탭이 닫혀 이동하지 못했습니다. 같은 내용으로 다시 시도해 주세요.',
    'The order tab was closed before it could proceed. Please retry with the same request.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_UNEXPECTED: [
    '요청을 준비하지 못했습니다. 다시 시도해 주세요.',
    'Could not prepare the request. Please try again.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_SERVER: [
    '서버 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    'A server error occurred. Please try again later.',
    undefined,
  ],
  // 서보셀렉터 구매 버튼(자격/선택/가용성 안내). 품목별 사유는 위 ITEM_NOT_FOUND/ITEM_NOT_ORDERABLE 을 재사용.
  I18N_CTP_PURCHASE_CHECKING: ['주문 가능 여부를 확인하는 중입니다...', 'Checking item availability...', undefined],
  I18N_CTP_PURCHASE_RETRY: ['다시 확인', 'Retry', undefined],
  I18N_CTP_PURCHASE_ERR_NO_SELECTION: ['선택된 품목이 없습니다.', 'No items are selected.', undefined],
  I18N_CTP_PURCHASE_ERR_ELIGIBILITY_FAILED: [
    '구매 자격을 확인하지 못했습니다. 다시 시도해 주세요.',
    'Could not verify purchase eligibility. Please try again.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_AVAILABILITY_FAILED: [
    '주문 가능 여부를 확인하지 못했습니다. 다시 시도해 주세요.',
    'Could not check item availability. Please try again.',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_ITEM_CODE_MISSING: [
    'ERP 품목코드가 없어 주문할 수 없습니다: {{item}}',
    'Cannot order without an ERP item code: {{item}}',
    undefined,
  ],
  I18N_CTP_PURCHASE_ERR_SELECTION_UNRESOLVED: [
    '선택 항목을 확인할 수 없어 주문할 수 없습니다: {{item}}',
    'Cannot order an unrecognized selection: {{item}}',
    undefined,
  ],
  I18N_UNKNOWN: ['UNKNOWN', 'UNKNOWN', undefined],

  i18n_ai_srch_result: ['AI 검색 결과', 'AI Search Result', undefined],
  i18n_ai_srch_more: ['AI 검색 결과 더보기', 'View More AI Search Results', undefined],
  i18n_ai_srch_sources: ['출처', 'References', undefined],
  i18n_ai_srch_error: [
    'AI 검색 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
    'An error occurred during AI search. Please try again later.',
    undefined,
  ],
  i18n_ai_srch_close: ['닫기', 'Close', undefined],
};

export type RES_COMMON = keyof typeof resi18n_common;

const [ko, en, enus] = resi18nutil.getres(resi18n_common);

export const resi18n_common_ko = ko;
export const resi18n_common_en = en;
export const resi18n_common_enus = enus;
